import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
const ResponseMsg = () => <ToastContainer />

export default ResponseMsg
